import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import CdnVideo from 'components/util/CdnVideo'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useState } from 'react'
import Slider from 'react-slick'
import VideoPlayer from '../common/video-player'
import './index.css'

interface Step {
  backgroundColor: string
  showImage: boolean
  image: any
  builderImage: any
  imageAltText: string
  showTopRightImage: boolean
  topRightImage: any
  topRightImageAlt: string
  name: string
  headline: string
  showHeadline: boolean
  text: string
  signature: string
  icon: any
  iconAlt: string
  tag: string
  cloudinaryVideo: any
  videoSrc: any
  videoShouldLoop: boolean
  playbackSettings: 'string'
  videoTagOwner: string
  videoTagDog: string
  videoRichText: string
}
interface Props {
  backgroundColor: string
  isVideoCard: boolean
  steps: Step[]
}

const ReviewCardCarousel = ({ backgroundColor, isVideoCard, steps }: Props) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [totalSlides, setTotalSlides] = useState(0)

  const handleAfterChange = (current: number) => {
    setCurrentSlide(current)
  }

  const SamplePrevArrow = (props: any) => {
    const { style, onClick, disabled } = props
    return (
      <div
        id="reviewArrowRight"
        style={{
          ...style,
          display: 'inline-flex',
          justifyContent: 'center',
          zIndex: 2,
          transform: 'translateY(-50%)',
          width: '1.6rem',
          height: '1.6rem',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto'
        }}
        onClick={disabled ? undefined : onClick}
      >
        <StaticImage className="w-8" src={'../../../../images/dog-details/dog-details-back.svg'} alt="Chevron left" />
      </div>
    )
  }

  const SampleNextArrow = (props: any) => {
    const { style, onClick, disabled } = props
    return (
      <div
        id="reviewArrowLeft"
        style={{
          ...style,
          display: 'inline-flex',
          justifyContent: 'center',
          zIndex: 2,
          transform: 'translateY(-50%)',
          width: '1.6rem',
          height: '1.6rem',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto'
        }}
        onClick={disabled ? undefined : onClick}
      >
        <StaticImage
          className="w-8 rotate-180"
          src={'../../../../images/dog-details/dog-details-back.svg'}
          alt="Chevron right"
        />
      </div>
    )
  }

  const settingsMobile = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      setCurrentSlide(next)
    },
    afterChange: handleAfterChange,
    prevArrow: <SamplePrevArrow disabled={currentSlide === 0} />,
    nextArrow: <SampleNextArrow disabled={currentSlide === totalSlides - 1} />,
    onInit: (slider: any) => {
      if (slider && slider.slideCount !== undefined) {
        setTotalSlides(slider.slideCount)
      }
    },
    onReInit: (slider: any) => {
      if (slider && slider.slideCount !== undefined) {
        setTotalSlides(slider.slideCount)
      }
    }
  }

  const renderImage = (step: any) => {
    return (
      <CdnImage
        className="index-2 relative w-11/12 mx-auto object-cover max-h-[16rem] h-[30rem] lg:max-h-[22rem] lg:h-[40rem] rounded-t-3xl mt-2"
        url={step?.builderImage}
        alt={step?.imageAltText}
        steps={[1080]}
        width={'500'}
      />

      // <>
      //   {step?.builderImage ? (
      //     <CdnImage
      //       className="index-2 relative w-11/12 mx-auto object-cover max-h-[16rem] h-[30rem] lg:max-h-[22rem] lg:h-[40rem] rounded-t-3xl mt-2"
      //       url={step?.builderImage}
      //       alt={step?.imageAltText}
      //       steps={[1080]}
      //       width={'500'}
      //     />
      //   ) : (
      //     <CloudinaryImage
      //       className="index-2 relative w-11/12 mx-auto object-cover max-h-[16rem] h-[30rem] lg:max-h-[22rem] lg:h-[40rem] rounded-t-3xl mt-2"
      //       publicId={step?.image?.public_id}
      //       alt={step?.imageAltText}
      //       loading={'eager'}
      //       steps={[1080]}
      //       width={500}
      //     />
      //   )}
      // </>
    )
  }

  return (
    <>
      <div className="m-auto w-full" style={{ backgroundColor }}>
        <div className="mx-auto max-w-7xl py-5 sm:px-2 sm:py-10 lg:px-4">
          {/* ================= Mobile Slider start */}
          <div className="relative flex justify-center md:hidden">
            <Slider {...settingsMobile} style={{ width: '100%' }}>
              {steps?.map((step: Step, i: number) => (
                <div key={i} className="mx-auto md:!flex h-full max-w-sm justify-center">
                  {!isVideoCard && (
                    <>
                      {step?.showImage && renderImage(step)}
                      <div
                        className={`relative w-11/12 mx-auto p-4 flex flex-col items-start ${step?.showImage ? 'rounded-b-3xl min-h-[32rem] h-auto mb-4' : 'rounded-3xl my-2'}`}
                        style={{ backgroundColor: step?.backgroundColor }}
                      >
                        {step?.showTopRightImage && (
                          <div className="absolute top-0 right-0 m-4">
                            <img
                              className="h-auto w-auto"
                              src={step?.topRightImage}
                              alt={step?.topRightImageAlt}
                              loading="lazy"
                            />
                          </div>
                        )}
                        <div className="flex flex-row justify-start items-center absolute top-0 left-0 m-4">
                          {step?.name && (
                            <div>
                              <p className="font-third font-normal text-3xl lg:text-4xl">{step?.name}</p>
                            </div>
                          )}
                        </div>

                        <div className={`${step?.name || step?.showImage ? 'mt-10' : ''} flex flex-col w-full`}>
                          {step?.showHeadline && (
                            <div className="flex justify-start items-start mb-1">
                              <p
                                className={`enable-list-styles text-sm lg:text-base font-medium font-sans w-full text-left`}
                                dangerouslySetInnerHTML={{ __html: step?.headline }}
                              ></p>
                            </div>
                          )}
                          {step?.text && (
                            <div className="flex justify-start items-start w-full mb-1">
                              <p
                                className={`enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left py-2`}
                                dangerouslySetInnerHTML={{ __html: step?.text }}
                              ></p>
                            </div>
                          )}
                          {step?.signature && (
                            <div className="mb-1">
                              <p className="font-sans font-bold text-sm">{step?.signature}</p>
                            </div>
                          )}
                          <div className="flex flex-row items-center">
                            {step?.icon && (
                              <img className="h-auto w-6 pr-2" src={step?.icon} alt={step?.iconAlt} loading="lazy" />
                            )}
                            {step?.tag && (
                              <p
                                className={`enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left`}
                                dangerouslySetInnerHTML={{ __html: step?.tag }}
                              ></p>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {isVideoCard && (
                    <div className="flex flex-col w-full px-3 lg:px-6">
                      <div className={`video-container mx-auto h-full w-full video-rounded-corner`}>
                        {step?.videoSrc ? (
                          <CdnVideo
                            videoSrc={step?.videoSrc}
                            videoLoop={step?.videoShouldLoop}
                            imageSrc={step?.builderImage}
                            playbackSettings={step?.playbackSettings}
                            account={false}
                            width={250}
                          />
                        ) : (
                          <VideoPlayer
                            videoLoop={step?.videoShouldLoop}
                            videoSrc={step?.cloudinaryVideo?.secure_url}
                            imageSrc={step?.builderImage}
                            playbackSettings={step?.playbackSettings}
                          />
                        )}
                      </div>
                      {step?.videoTagDog && step?.videoTagOwner && (
                        <div className="flex justify-center pt-3">
                          <p className="font-sans font-normal text-lg"> {step?.videoTagOwner}</p>
                          <p className="font-sans font-normal text-lg">&nbsp;and&nbsp;</p>
                          <p className="font-third font-normal text-3xl">{step?.videoTagDog}</p>
                        </div>
                      )}
                      {step?.videoRichText && (
                        <p
                          className={`enable-list-styles pt-3 h-full text-center text-base w-full flex justify-center`}
                          dangerouslySetInnerHTML={{ __html: step?.videoRichText }}
                        ></p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </Slider>
          </div>
          {/* ================= Mobile Slider End*/}

          <div className="hidden md:flex md:justify-center">
            {steps?.map((step: Step, i: number) => (
              <div key={i} className={`flex flex-col w-full ${isVideoCard ? 'mx-auto h-full !w-4/5' : ''}`}>
                {!isVideoCard && (
                  <>
                    {step?.showImage && renderImage(step)}
                    <div
                      className={`relative w-11/12 mx-auto p-4 flex flex-col items-start rounded-b-3xl min-h-[30rem] h-full`}
                      style={{ backgroundColor: step?.backgroundColor }}
                    >
                      {step?.showTopRightImage && (
                        <div className="absolute top-0 right-0 m-4">
                          <img
                            className="h-auto w-auto"
                            src={step?.topRightImage}
                            alt={step?.topRightImageAlt}
                            loading="lazy"
                          />
                        </div>
                      )}
                      <div className="flex flex-row justify-start items-center absolute top-0 left-0 m-4">
                        {step?.name && (
                          <div>
                            <p className="font-third font-normal text-3xl lg:text-4xl">{step?.name}</p>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-col w-full mt-10">
                        {step?.showHeadline && (
                          <div className="flex justify-start items-start mb-1">
                            <p
                              className="enable-list-styles text-sm lg:text-base font-medium font-sans w-full text-left"
                              dangerouslySetInnerHTML={{ __html: step?.headline }}
                            ></p>
                          </div>
                        )}
                        {step?.text && (
                          <div className="flex justify-start items-start w-full mb-1">
                            <p
                              className="enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left py-2"
                              dangerouslySetInnerHTML={{ __html: step?.text }}
                            ></p>
                          </div>
                        )}
                        {step?.signature && (
                          <div className="mb-1">
                            <p className="font-sans font-bold text-lg">{step?.signature}</p>
                          </div>
                        )}
                        <div className="flex flex-row items-center">
                          {step?.icon && (
                            <img className="h-auto w-6 pr-2" src={step?.icon} alt={step?.iconAlt} loading="lazy" />
                          )}
                          {step?.tag && (
                            <p
                              className="enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left"
                              dangerouslySetInnerHTML={{ __html: step?.tag }}
                            ></p>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {isVideoCard && (
                  <div className="flex flex-col w-full h-full px-3 lg:px-6">
                    <div className="video-container mx-auto h-full w-full video-rounded-corner">
                      {step?.videoSrc ? (
                        <CdnVideo
                          videoSrc={step?.videoSrc}
                          videoLoop={step?.videoShouldLoop}
                          imageSrc={step?.builderImage}
                          playbackSettings={step?.playbackSettings}
                          account={false}
                          width={368}
                        />
                      ) : (
                        <VideoPlayer
                          videoLoop={step?.videoShouldLoop}
                          videoSrc={step?.cloudinaryVideo?.secure_url}
                          imageSrc={step?.builderImage}
                          playbackSettings={step?.playbackSettings}
                        />
                      )}
                    </div>
                    {step?.videoTagDog && step?.videoTagOwner && (
                      <div className="flex justify-center pt-3">
                        <p className="font-sans font-normal text-lg">{step?.videoTagOwner}</p>
                        <p className="font-sans font-normal text-lg">&nbsp;and&nbsp;</p>
                        <p className="font-third font-normal text-3xl">{step?.videoTagDog}</p>
                      </div>
                    )}
                    {step?.videoRichText && (
                      <p
                        className={`enable-list-styles pt-3 h-full text-center text-base w-full flex justify-center`}
                        dangerouslySetInnerHTML={{ __html: step?.videoRichText }}
                      ></p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default ReviewCardCarousel

Builder.registerComponent(ReviewCardCarousel, {
  name: 'ReviewCardCarousel',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'isVideoCard',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'steps',
      type: 'list',
      defaultValue: [
        {
          backgroundColor: '#f9f5f1',
          showImage: false,
          image: null,
          builderImage: null,
          imageAltText: '',
          showTopRightImage: false,
          topRightImage: null,
          topRightImageAlt: '',
          name: '',
          headline: '',
          showHeadline: true,
          text: '',
          signature: '',
          icon: null,
          iconAlt: '',
          tag: '',
          cloudinaryVideo: null,
          videoSrc: null,
          playbackSettings: '',
          videoShouldLoop: false,
          videoTagOwner: '',
          videoTagDog: '',
          videoRichText: ''
        }
      ],
      subFields: [
        {
          name: 'backgroundColor',
          type: 'color',
          defaultValue: '#f9f5f1'
        },
        {
          name: 'showImage',
          type: 'boolean',
          defaultValue: false
        },
        // { name: 'image', type: 'cloudinaryImageEditor' },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        { name: 'imageAltText', type: 'text', defaultValue: '' },
        {
          name: 'showTopRightImage',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'topRightImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        {
          name: 'topRightImageAlt',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'name',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'headline',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'showHeadline',
          type: 'boolean',
          defaultValue: true
        },
        {
          name: 'text',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'signature',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'icon',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        {
          name: 'iconAlt',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'tag',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'cloudinaryVideo',
          type: 'cloudinaryImageEditor'
        },
        {
          name: 'videoSrc',
          type: 'file',
          defaultValue: null,
          allowedFileTypes: ['mp4']
        },
        {
          name: 'playbackSettings',
          type: 'string',
          enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
          defaultValue: 'Muted with auto play off'
        },
        {
          name: 'videoShouldLoop',
          type: 'boolean',
          defaultValue: true
        },
        {
          name: 'videoTagOwner',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'videoTagDog',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'videoRichText',
          type: 'richText',
          defaultValue: ''
        }
      ]
    }
  ]
})
